//Driver for audit scoring any Reads

import axios from "axios";

export default {
	icon: "check",
	name: "View All",
	showScores() {
		return false;
	},
	sidebarType() {
		return "viewing";
	},
	nextWithoutSubmit: true,
	multiItem: true,
	canBeEscalated: true,

	getNext() {
		var promise = axios.get(`/v3/recent_unread/`);
		promise.then(function(resp) {
			console.log("ViewAllSD GetNext:" + resp.data.response.ref_id);
		});
		return promise;
	}
};



// WEBPACK FOOTER //
// ./src/services/ScoringDrivers/ViewAllDriver.js